// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const RewindIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Rewind/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.067 11.2a1 1 0 0 0 0 1.6l5.333 4A1 1 0 0 0 19 16V8a1 1 0 0 0-1.6-.8l-5.333 4ZM4.067 11.2a1 1 0 0 0 0 1.6l5.333 4A1 1 0 0 0 11 16V8a1 1 0 0 0-1.6-.8l-5.333 4Z"
}));
export default RewindIcon;